/* ADDED */

// When the Cart Drawer updates, update other producty qty selectors

const parentElement = document.querySelector('cart-drawer');

// Also handle clicks in recommendations panel
parentElement.addEventListener('click', function(event) {
  // Handle quantity changes in recommendations
  if (event.target.closest('.cart-recommendations-container')) {
    const quantityControl = event.target.closest('.quantity');
    if (quantityControl && event.target.classList.contains('quantity__button')) {
      const inputElement = quantityControl.querySelector('input');
      const productID = inputElement.getAttribute('data-product-id');
      const qtyDirection = event.target.getAttribute('name');
      
      const cartDrawerItem = document.querySelector(`cart-drawer .cart-item [data-product-id='${productID}']`);
      if (cartDrawerItem) {
        const cartDrawerItemButton = cartDrawerItem.parentElement.querySelector(`button[name='${qtyDirection}']`);
        
        if (cartDrawerItemButton && !cartDrawerItemButton.disabled) {
          cartDrawerItemButton.click();
          
          // Update recommendation totals after cart updates
          setTimeout(() => {
            const cartDrawerElement = document.querySelector('cart-drawer');
            if (cartDrawerElement && cartDrawerElement.isRecommendationsView) {
              cartDrawerElement.updateRecommendationTotals();
            }
          }, 1000);
        }
      }
    }
  }
});

parentElement.addEventListener('click', function(event) {

//console.log(event.target.parentElement);

  if (event.target.parentElement.classList.contains('quantity')) {
    const inputElement = event.target.parentElement.querySelector('input');
    const productID = inputElement.getAttribute('data-product-id');
    const quantityValue = parseInt(inputElement.value);
    const maxQuantity = parseInt(inputElement.getAttribute('max'));

    console.log('Quantity changing to: ' + quantityValue + ' for Product ID: ' + productID);

    // disable this button to prevent hammering, renabled in cart.js
    const quantityButtons = document.querySelectorAll('.quantity__button');
    quantityButtons.forEach(button => {
      button.disabled = true;
      button.style.opacity = 0.25;
    });

    // Find any other inputs of the same product id and change its value
    const quantityInputs = document.querySelectorAll(`.quantity__input[data-product-id='${productID}']`);
    quantityInputs.forEach(function(quantityInput) {
        quantityInput.value = quantityValue;
        //console.log('Quantity changed to:', quantityValue);
    });

    if (quantityValue >= maxQuantity) {
      console.error('Max quantity reached for Product ID: ' + productID);
      console.log('Max quantity is: ' + maxQuantity);
      console.log('Current quantity is: ' + quantityValue);
      //console.log('quantityValue:', quantityValue, 'type:', typeof quantityValue);
      //console.log('maxQuantity:', maxQuantity, 'type:', typeof maxQuantity);

      // Keep the plus disabled so users dont keep trying
      quantityInputs.forEach(function(quantityInput) {
        quantityInput.parentElement.querySelector('button[name="plus"]').disabled = true;
        quantityInput.parentElement.querySelector('button[name="plus"]').style.opacity = 0.25;
        quantityInput.parentElement.querySelector('button[name="plus"]').setAttribute('limit-reached', 'true');
      });

      // wait 1 second and renable the buttons, as they wont otherwise
      setTimeout(() => {
        quantityButtons.forEach(button => {
          if (!button.hasAttribute('limit-reached')) {
            button.disabled = false;
            button.style.opacity = 1;
          }
        });
      }, 1000);

    } else {
      // remove the limit-reached attribute if it exists
      quantityInputs.forEach(function(quantityInput) {
        quantityInput.parentElement.querySelector('button[name="plus"]').removeAttribute('limit-reached');
      });
    }



    if (quantityValue == 0) { // If 0, act as if it was removed and reset the relevant buttons.
      
      /* DIRECT COPY FROM CartRemoveButton FUNCTION */

      // Find any boost product grid items of the same ID and reset.
      const boostProductItems = document.querySelectorAll(`.boost-pfs-filter-product-item[data-id='${productID}']`);
      boostProductItems.forEach(function(boostProductItem) { // Probably only every 1 shown, but lets just loop it
        boostProductItem.classList.remove("boost-pfs-added");
        boostProductItem.querySelector('.quantity__input').value = 1; // Reset incase user adds again
      });

      // Find any product page items of the same ID and reset.
      const productForm = document.querySelector(`.unero-single-product-detail product-form[data-id='${productID}']`);
      if (productForm) {
        const productQty = document.querySelector(`.unero-single-product-detail .product-form__input[data-id='${productID}']`);
        productForm.classList.remove("hide");
        productQty.classList.add("hide");
        productQty.querySelector('.quantity__input').value = 1; // Reset in case user adds again
      }

      const ppProductItems = document.querySelectorAll(`.pp-item[data-product-id='${productID}']`);
      
      ppProductItems.forEach((ppProductItem) => {
        ppProductItem.classList.remove("is--in-cart");
      
        const addToCartBtn = ppProductItem.querySelector('.pp-item__add-to-cart');
        addToCartBtn.classList.remove("hide");
        addToCartBtn.classList.add("removing");
        addToCartBtn.disabled = true;
        setTimeout(() => {
          addToCartBtn.disabled = false;
          addToCartBtn.classList.remove("removing");
        }, 3000);
      
        ppProductItem.querySelector('.pp-item__quantity').classList.add("hide");
        ppProductItem.querySelector('.quantity__input').value = 1; // Reset in case user adds again
        console.log(ppProductItem.querySelector('.quantity__input').value);
      });


    }

  }
});




// When a user clicks the QTY changer on product form, pass a click to the cart drawer element to handle the functionality.
// Ideal way to do this would be with section rendering, but out of scope at the moment.

const productForm = document.querySelector('.product-form__input quantity-input.non-cart');

if (productForm) {

  productForm.addEventListener('click', function(event) {


    if (event.target.parentElement.classList.contains('quantity')) {
      const inputElement = event.target.parentElement.querySelector('input');
      const qtyDirection = event.target.getAttribute('name');
      const productID = inputElement.getAttribute('data-product-id');

      const cartDrawerItem = document.querySelector(`cart-drawer .quantity__input[data-product-id='${productID}']`);
      const cartDrawerItemButton = cartDrawerItem.parentElement.querySelector(`button[name='${qtyDirection}']`)

      if (!cartDrawerItemButton.disabled) {
        cartDrawerItemButton.click();

      // disable this button to prevent hammering, renabled in cart.js
       const quantityButtons = document.querySelectorAll('.quantity__button');
       quantityButtons.forEach(button => {
         button.disabled = true;
         button.style.opacity = 0.25;
       });

      } else {
        console.log('Button is disabled cannot send click to cart drawer');

        // set this button to be disabled to prevent more clicks
        event.target.disabled = true;
        event.target.style.opacity = 0.25;

      }
    
    }
  });

}

// Direct copy of above, but for pp page

const previouslyPurchasedGrid = document.querySelector('.pp__collections');

if (previouslyPurchasedGrid) {

  previouslyPurchasedGrid.addEventListener('click', function(event) {

    if (event.target.parentElement.classList.contains('quantity')) {

      const inputElement = event.target.parentElement.querySelector('input');
      const qtyDirection = event.target.getAttribute('name');
      const productID = inputElement.getAttribute('data-product-id');

      const cartDrawerItem = document.querySelector(`cart-drawer .quantity__input[data-product-id='${productID}']`);
      const cartDrawerItemButton = cartDrawerItem.parentElement.querySelector(`button[name='${qtyDirection}']`)

      if (!cartDrawerItemButton.disabled) {
        cartDrawerItemButton.click();

      // disable this button to prevent hammering, renabled in cart.js
       const quantityButtons = document.querySelectorAll('.quantity__button');
       quantityButtons.forEach(button => {
         button.disabled = true;
         button.style.opacity = 0.25;
       });

      } else {
        console.log('Button is disabled cannot send click to cart drawer');

        // set this button to be disabled to prevent more clicks
        event.target.disabled = true;
        event.target.style.opacity = 0.25;

      }
    
    }
  });

}


// Direct copy of above, but for product boost grid 
const productGrid = document.querySelector('.boost-pfs-filter-products');

if (productGrid) {

  productGrid.addEventListener('click', function(event) {

    if (event.target.parentElement.classList.contains('quantity')) {

      const inputElement = event.target.parentElement.querySelector('input');
      const qtyDirection = event.target.getAttribute('name');
      const productID = inputElement.getAttribute('data-product-id');

      const cartDrawerItem = document.querySelector(`cart-drawer .quantity__input[data-product-id='${productID}']`);
      const cartDrawerItemButton = cartDrawerItem.parentElement.querySelector(`button[name='${qtyDirection}']`)

      if (!cartDrawerItemButton.disabled) {
        cartDrawerItemButton.click();

      // disable this button to prevent hammering, renabled in cart.js
       const quantityButtons = document.querySelectorAll('.quantity__button');
       quantityButtons.forEach(button => {
         button.disabled = true;
         button.style.opacity = 0.25;
       });

      } else {
        console.log('Button is disabled cannot send click to cart drawer');

        // set this button to be disabled to prevent more clicks
        event.target.disabled = true;
        event.target.style.opacity = 0.25;

      }
    
    }
  });

}



document.addEventListener('DOMContentLoaded', function() {
  const cartDrawer = document.querySelector('cart-drawer');
  const referrer = document.referrer;

  if (referrer.includes('/cart') && cartDrawer) {
      cartDrawer.open();
  }
});

document.addEventListener('DOMContentLoaded', function() {
  if (window.location.href.indexOf("#cart") > -1) {
    console.log("Opening Cart");

    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      cartDrawer.open();
    }
  }
});






/* ORIGINAL FROM DAWN */

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    //this.setHeaderCartIconAccessibility();
    
    // Recommendations state
    this.recommendationsCache = null;
    this.recommendationsLoading = false;
    this.isRecommendationsView = false;
    
    // Set up event listeners for recommendations
    this.setupRecommendationsListeners();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
    
    // Preload recommendations in background
    if (this.shouldShowRecommendations()) {
      this.preloadRecommendations();
    }
  }

  close() {
    this.classList.remove('active');
    this.classList.remove('show-recommendations');
    this.isRecommendationsView = false;
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');

    document.body.classList.remove('modal-open');
    
    // Reset recommendations view when closing
    this.hideRecommendationsPanel();
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      //this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble',
        selector: '.cart-content'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  // ============================================
  // RECOMMENDATIONS FUNCTIONALITY
  // ============================================

  setupRecommendationsListeners() {
    // Intercept checkout button clicks
    document.addEventListener('click', (e) => {
      const checkoutBtn = e.target.closest('#CartDrawer-Checkout');
      if (checkoutBtn && !this.isRecommendationsView) {
        if (this.shouldShowRecommendations()) {
          e.preventDefault();
          e.stopPropagation();
          this.handleCheckoutClick();
        }
      }
    }, true); // Use capture phase to intercept before form submission

    // Back button
    const backBtn = this.querySelector('#recommendations-back-btn');
    if (backBtn) {
      backBtn.addEventListener('click', () => this.hideRecommendationsPanel());
    }

    // Proceed to payment button
    const proceedBtn = this.querySelector('#recommendations-checkout-btn');
    if (proceedBtn) {
      proceedBtn.addEventListener('click', () => this.proceedToCheckout());
    }
  }

  shouldShowRecommendations() {
    // Respect feature flag
    if (!window.cartRecommendationsData?.enabled) return false;

    // Don't show if cart is empty
    const cartItems = document.querySelectorAll('#CartDrawer .cart-item');
    if (cartItems.length === 0) return false;

    return true;
  }

  async handleCheckoutClick() {
    console.log('=== Checkout intercepted, showing recommendations ===');
    
    // Show recommendations panel immediately
    this.showRecommendationsPanel();
    
    // If already loaded, render them
    if (this.recommendationsCache && this.recommendationsCache.handles && this.recommendationsCache.handles.length > 0) {
      console.log('=== Using cached recommendations ===');
      await this.renderRecommendationProducts(this.recommendationsCache.handles, this.recommendationsCache.type);
    } else if (!this.recommendationsLoading) {
      // Otherwise fetch and render
      try {
        const result = await this.fetchRecommendations();
        if (result && result.handles && result.handles.length > 0) {
          await this.renderRecommendationProducts(result.handles, result.type);
        } else {
          // No recommendations, proceed to checkout
          console.log('=== No recommendations available, proceeding to checkout ===');
          this.proceedToCheckout();
        }
      } catch (error) {
        console.error('=== Error fetching recommendations, proceeding to checkout ===', error);
        this.proceedToCheckout();
      }
    }
  }

  async preloadRecommendations() {
    // Check cache first
    const cached = this.getRecommendationsFromCache();
    if (cached) {
      console.log('=== Found cached recommendations ===');
      this.recommendationsCache = cached;
      return;
    }

    // Fetch in background
    if (!this.recommendationsLoading) {
      console.log('=== Preloading recommendations in background ===');
      this.recommendationsLoading = true;
      try {
        const result = await this.fetchRecommendations();
        this.recommendationsCache = result;
        this.cacheRecommendations(result);
        console.log('=== Recommendations preloaded ===', result);
      } catch (error) {
        console.error('=== Error preloading recommendations ===', error);
      } finally {
        this.recommendationsLoading = false;
      }
    }
  }

  async fetchRecommendations() {
    console.log('=== Fetching recommendations ===');
    
    // Try previously purchased first if customer is logged in
    if (window.cartRecommendationsData && window.cartRecommendationsData.customerId) {
      console.log('=== Customer logged in, trying previously purchased ===');
      try {
        const ppResult = await this.fetchPreviouslyPurchased();
        if (ppResult && ppResult.length >= 5) {
          console.log(`=== Found ${ppResult.length} previously purchased items ===`);
          return { handles: ppResult.slice(0, 10), type: 'previously-purchased' };
        } else {
          console.log(`=== Only ${ppResult ? ppResult.length : 0} previously purchased items, falling back to Shopify recommendations ===`);
        }
      } catch (error) {
        console.error('=== Error fetching previously purchased, falling back ===', error);
      }
    }

    // Fall back to Shopify recommendations
    console.log('=== Fetching Shopify recommendations ===');
    const shopifyRecs = await this.fetchShopifyRecommendations();
    return { handles: shopifyRecs.slice(0, 10), type: 'you-may-like' };
  }

  async fetchPreviouslyPurchased() {
    const customerId = window.cartRecommendationsData.customerId;
    const url = `https://pp-get-bought-before.chris-d45.workers.dev/?customer_id=${customerId}`;
    
    console.log('=== Calling previously purchased API ===', url);
    
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 5000);
    
    try {
      const response = await fetch(url, { signal: controller.signal });
      clearTimeout(timeoutId);
      
      if (!response.ok) {
        throw new Error(`API returned ${response.status}`);
      }
      
      const data = await response.json();
      console.log('=== Previously purchased data ===', data);
      
      if (!data.products || data.products.length === 0) {
        return [];
      }

      // Convert product IDs to handles
      const productIds = data.products.map(id => id.toString());
      const handles = await this.convertProductIdsToHandles(productIds);
      
      // Filter out products already in cart
      const cartProductIds = this.getCartProductIds();
      const filteredHandles = handles.filter((handle, index) => {
        return !cartProductIds.includes(productIds[index]);
      });
      
      return filteredHandles;
    } catch (error) {
      if (error.name === 'AbortError') {
        console.error('=== Previously purchased API timeout ===');
      } else {
        console.error('=== Previously purchased API error ===', error);
      }
      throw error;
    }
  }

  async convertProductIdsToHandles(productIds) {
    console.log('=== Converting product IDs to handles ===', productIds);
    const handles = [];
    const concurrencyLimit = 5;
    const queue = [];

    for (const productId of productIds) {
      const fetchPromise = (async () => {
        try {
          const response = await fetch(`/products/${productId}.js`);
          if (response.ok) {
            const product = await response.json();
            if (product.handle && product.available) {
              handles.push(product.handle);
            }
          }
        } catch (error) {
          console.error(`=== Error fetching product ${productId} ===`, error);
        }
      })();

      queue.push(fetchPromise);

      if (queue.length >= concurrencyLimit) {
        await Promise.race(queue);
        const finishedIndex = queue.findIndex(p => p === fetchPromise);
        if (finishedIndex !== -1) {
          queue.splice(finishedIndex, 1);
        }
      }
    }

    await Promise.all(queue);
    console.log('=== Converted handles ===', handles);
    return handles;
  }

  async fetchShopifyRecommendations() {
    console.log('=== Fetching Shopify recommendations ===');
    
    // Get first 5 cart items
    const cartItems = Array.from(document.querySelectorAll('#CartDrawer .cart-item'));
    const cartProductIds = cartItems
      .slice(0, 5)
      .map(item => item.getAttribute('data-product-id'))
      .filter(id => id);

    console.log('=== Cart product IDs for recommendations ===', cartProductIds);

    if (cartProductIds.length === 0) {
      return [];
    }

    const allRecommendations = [];
    const concurrencyLimit = 5;
    const queue = [];

    for (const productId of cartProductIds) {
      const fetchPromise = (async () => {
        try {
          const controller = new AbortController();
          const timeoutId = setTimeout(() => controller.abort(), 5000);
          
          const response = await fetch(`/recommendations/products.json?product_id=${productId}&limit=5`, {
            signal: controller.signal
          });
          clearTimeout(timeoutId);
          
          if (response.ok) {
            const data = await response.json();
            if (data.products && data.products.length > 0) {
              data.products.forEach(product => {
                if (product.available && product.handle) {
                  allRecommendations.push({
                    handle: product.handle,
                    id: product.id.toString()
                  });
                }
              });
            }
          }
        } catch (error) {
          console.error(`=== Error fetching recommendations for product ${productId} ===`, error);
        }
      })();

      queue.push(fetchPromise);

      if (queue.length >= concurrencyLimit) {
        await Promise.race(queue);
        const finishedIndex = queue.findIndex(p => p === fetchPromise);
        if (finishedIndex !== -1) {
          queue.splice(finishedIndex, 1);
        }
      }
    }

    await Promise.all(queue);

    // Deduplicate and rank by frequency
    const handleCounts = {};
    allRecommendations.forEach(rec => {
      handleCounts[rec.handle] = (handleCounts[rec.handle] || 0) + 1;
    });

    // Sort by frequency, then remove duplicates
    const uniqueHandles = Object.keys(handleCounts).sort((a, b) => handleCounts[b] - handleCounts[a]);
    
    // Filter out products already in cart
    const cartIds = this.getCartProductIds();
    const filteredHandles = uniqueHandles.filter(handle => {
      const rec = allRecommendations.find(r => r.handle === handle);
      return !cartIds.includes(rec.id);
    });

    console.log('=== Shopify recommendations (filtered and ranked) ===', filteredHandles);
    return filteredHandles;
  }

  getCartProductIds() {
    const cartItems = document.querySelectorAll('#CartDrawer .cart-item');
    return Array.from(cartItems).map(item => item.getAttribute('data-product-id'));
  }

  async renderRecommendationProducts(handles, type) {
    console.log('=== Rendering recommendations ===', handles, type);
    
    const container = this.querySelector('#cart-recommendations-container');
    const loading = this.querySelector('.cart-drawer__recommendations-loading');
    const error = this.querySelector('.cart-drawer__recommendations-error');
    const empty = this.querySelector('.cart-drawer__recommendations-empty');
    const heading = this.querySelector('#recommendations-heading');
    const helper = this.querySelector('.recommendations__helper-text');

    // Hide loading
    if (loading) loading.style.display = 'none';
    if (error) error.style.display = 'none';
    if (empty) empty.style.display = 'none';

    // Update heading based on type
    if (heading) {
      heading.textContent = type === 'previously-purchased' ? 'Have you forgotten' : 'You may also like';
    }
    if (helper) {
      helper.textContent = type === 'previously-purchased' 
        ? 'Products you\'ve purchased before' 
        : 'Recommended products for you';
    }

    if (!handles || handles.length === 0) {
      if (empty) empty.style.display = 'block';
      // Proceed to checkout after short delay
      setTimeout(() => this.proceedToCheckout(), 2000);
      return;
    }

    // Clear container
    container.innerHTML = '';

    // Fetch and render each product
    const concurrencyLimit = 5;
    const queue = [];

    for (const handle of handles) {
      const fetchPromise = (async () => {
        try {
          const response = await fetch(`/products/${handle}?view=cart-rec`);
          if (response.ok) {
            const html = await response.text();
            console.log(`=== Fetched product ${handle}, length: ${html.length} ===`);
            if (html && html.trim().length > 0) {
              container.insertAdjacentHTML('beforeend', html);
              console.log(`=== Inserted product ${handle} ===`);
            } else {
              console.error(`=== Empty response for ${handle} ===`);
            }
          } else {
            console.error(`=== Response not OK for ${handle}: ${response.status} ===`);
          }
        } catch (error) {
          console.error(`=== Error rendering product ${handle} ===`, error);
        }
      })();

      queue.push(fetchPromise);

      if (queue.length >= concurrencyLimit) {
        await Promise.race(queue);
        const finishedIndex = queue.findIndex(p => p === fetchPromise);
        if (finishedIndex !== -1) {
          queue.splice(finishedIndex, 1);
        }
        await new Promise(resolve => setTimeout(resolve, 100));
      }
    }

    await Promise.all(queue);
    
    console.log('=== Recommendations rendered ===');
    
    // Update totals
    this.updateRecommendationTotals();
  }

  showRecommendationsPanel() {
    console.log('=== Showing recommendations panel ===');
    this.classList.add('show-recommendations');
    this.isRecommendationsView = true;
    
    const panel = this.querySelector('.cart-drawer__recommendations-panel');
    if (panel) {
      panel.style.display = 'flex';
    }

    // Show loading state
    const loading = this.querySelector('.cart-drawer__recommendations-loading');
    if (loading) loading.style.display = 'flex';
  }

  hideRecommendationsPanel() {
    console.log('=== Hiding recommendations panel ===');
    this.classList.remove('show-recommendations');
    this.isRecommendationsView = false;
    
    // Reset panel after transition
    setTimeout(() => {
      const panel = this.querySelector('.cart-drawer__recommendations-panel');
      if (panel && !this.isRecommendationsView) {
        panel.style.display = 'none';
      }
    }, 300);
  }

  updateRecommendationTotals() {
    // Get current cart data from the page
    const cartForm = document.querySelector('#CartDrawer-Form');
    if (!cartForm) return;

    // Update totals in recommendations footer
    const totalDisplay = this.querySelector('#recommendations-total');
    const checkoutTotal = this.querySelector('#recommendations-checkout-total');
    const savingsDisplay = this.querySelector('#recommendations-savings');
    const savingsPanel = this.querySelector('.cart-drawer__recommendations-footer .cart__saving-panel');

    // Get totals from the main cart display
    const mainSavings = document.querySelector('.cart__ctas .cart__saving-panel span:last-child');
    const mainCheckoutBtn = document.querySelector('#CartDrawer-Checkout span:last-child');

    if (mainCheckoutBtn && totalDisplay && checkoutTotal) {
      const totalText = mainCheckoutBtn.textContent.trim();
      totalDisplay.textContent = totalText;
      checkoutTotal.textContent = totalText;
    }

    if (mainSavings && savingsDisplay && savingsPanel) {
      const savingsText = mainSavings.textContent.trim();
      savingsDisplay.textContent = savingsText;
    }
  }

  proceedToCheckout() {
    console.log('=== Proceeding to checkout ===');
    // Submit the cart form to checkout
    const form = document.querySelector('#CartDrawer-Form');
    if (form) {
      // Create a hidden input for checkout
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'checkout';
      input.value = '';
      form.appendChild(input);
      form.submit();
    } else {
      // Fallback to direct navigation
      window.location.href = '/checkout';
    }
  }

  cacheRecommendations(data) {
    if (!data || !data.handles) return;
    
    const cacheData = {
      handles: data.handles,
      type: data.type,
      timestamp: Date.now(),
      cartToken: this.getCartToken()
    };
    
    try {
      sessionStorage.setItem('cart_recommendations', JSON.stringify(cacheData));
      console.log('=== Recommendations cached ===');
    } catch (error) {
      console.error('=== Error caching recommendations ===', error);
    }
  }

  getRecommendationsFromCache() {
    try {
      const cached = sessionStorage.getItem('cart_recommendations');
      if (!cached) return null;
      
      const data = JSON.parse(cached);
      
      // Check if cache is expired (5 minutes)
      const age = Date.now() - data.timestamp;
      if (age > 300000) {
        console.log('=== Cache expired ===');
        sessionStorage.removeItem('cart_recommendations');
        return null;
      }
      
      // Check if cart has changed
      const currentToken = this.getCartToken();
      if (data.cartToken !== currentToken) {
        console.log('=== Cart changed, cache invalid ===');
        sessionStorage.removeItem('cart_recommendations');
        return null;
      }
      
      return data;
    } catch (error) {
      console.error('=== Error reading cache ===', error);
      return null;
    }
  }

  getCartToken() {
    // Use cart item count and first product ID as a simple token
    const cartItems = document.querySelectorAll('#CartDrawer .cart-item');
    const count = cartItems.length;
    const firstId = cartItems[0]?.getAttribute('data-product-id') || '';
    return `${count}-${firstId}`;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      } ,
      {
        id: 'icon-cart-contents',
        section: 'cart-icon-bubble',
        selector: '.cart-content'
      } 
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
